<template>
  <div>
    <TopBar :title="title" :isIndex="false" :shareData="shareData" />
    <div
      :class="isSmartCityApp ? '' : 'noSmart'"
      class="container"
      ref="container"
    >
      <div class="intr">
        <div class="title">{{ info.title }}</div>
        <!-- <div class="names">{{ info.names }}</div> -->
        <div class="mainImg" @click="imgPreView(info.content)">
          <img v-lazy="info.url" alt="" />
        </div>
        <!-- <div class="content">{{ info.content }}</div> -->
        <!-- <div class="voteInfo">{{ info.sex }}</div> -->
        <div class="voteInfo">{{ info.number }}·{{ info.voteNum }}票</div>

        <!-- <video
          id="myVideo"
          class="myVideo"
          controls
          preload="auto"
          width="100%"
          autoplay
          :poster="info.picUrl"
          webkit-playsinline="true"
          playsinline="true"
          x5-video-player-type="h5"
          x5-video-orientation="landscape"
        >
          <source v-if="info.url" :src="info.url" />
        </video> -->
      </div>
      <!-- title 姓名
sex   性别
recommend 出生年月
real_name 工作单位
intro  推荐单位
descr  描述
url    图片
area   地区 -->
      <div class="infoContent">
        <div class="insideContent">
          <div class="infoDetail">
            <div class="felxCenter">
              <div class="mainTitle">{{ info.title }}</div>
              <div class="title">{{ info.realName }}</div>
            </div>
            <!-- <div class="flexBetween">
              <div class="programName">出生年月：</div>
              <div class="title">{{ info.recommend }}</div>
            </div>
            <div class="flexBetween">
              <div class="programName">工作单位：</div>
              <div class="title">{{ info.realName }}</div>
            </div> -->
            <!-- <div class="flexBetween">
              <div class="programName">推荐单位：</div>
              <div class="title">{{ info.intro }}</div>
            </div>
            <div class="flexBetween">
              <div class="programName">地区：</div>
              <div class="title">{{ info.area }}</div>
            </div> -->
            <!-- <div class="flexBetween">
              <div class="programName">描述：</div>
              <div class="title"></div>
            </div> -->
            <div class="infoText">{{ info.descr }}</div>
          </div>
        </div>
      </div>
      <div class="backBtn" @click="backPage">返回</div>
      <van-dialog
        v-model="showDialog"
        title="请输入验证码"
        :before-close="beforeClose"
        show-cancel-button
      >
        <div class="verify flexBetween">
          <van-field
            style="width: 70%"
            v-model="code"
            placeholder="在此输入验证码"
          ></van-field>
          <img :src="codeUrl" alt="" @click="onUpdateCode" />
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { worksVote, browseProgram } from "@/api/childrenVote";
import { ImagePreview } from "vant";
import TopBar from "../components/TopBar";
export default {
  name: "Detail",
  data() {
    return {
      info: {},
      isIos: false,
      countDown: 30,
      wxCloseVideo: false,
      showDialog: false,
      code: null,
      codeUrl: "",
      targetId: null,
      title: "详情",
      shareData: {},
      id: null,
      ifAssisted: false,
      isSmartCityApp: false,
      playerOptions: {},
      activeTab: "",
      jumpUrl: "http://share.plus.hugd.com/app/jump/2022/zmhzrVote",
    };
  },
  components: { TopBar },
  methods: {
    getImgCode() {
      axios({
        method: "post",
        headers: {
          token: this.$store.state.nthUserInfo.userTokenKey,
        },
        url: "https://server.zhijianmedia.cn/childVote/home/getImgCode",
        responseType: "arraybuffer",
      }).then((res) => {
        this.codeUrl =
          "data:image/png;base64," +
          btoa(
            new Uint8Array(res.data).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
      });
    },
    beforeClose(action, done) {
      console.log(action);
      if (action === "cancel") {
        return done(true);
      } else {
        this.vote(action, done);
      }
    },
    async vote(action, done) {
      // if (!this.code) {
      //   done(false);
      //   return this.$toast("请输入验证码");
      // }

      const { data: res } = await worksVote({
        // code: this.code,
        programId: this.targetId,
      });

      if (res.code == 200) {
        // done(true);
        this.code = "";
        this.$toast.success(res.mes);
        this.ifAssisted = true;
      } else {
        // done(true);
        this.code = "";
        return this.$toast.fail(res.mes);
      }
    },
    onUpdateCode() {
      this.getImgCode();
    },
    async onSave() {
      if (SmartCity.isSmartCityApp()) {
        this.targetId = this.info.id;
        // this.getImgCode();
        // this.showDialog = true;
        this.vote();
      } else {
        this.goApp();
      }
    },
    goApp() {
      window.location.href = this.jumpUrl;
      // "http://share.plus.hugd.com/app/jump/2022/xinghaibei";
    },
    imgPreView(url) {
      ImagePreview({
        images: [url],
      });
    },
    async browseProgram() {
      let params = {
        programId: this.id,
      };
      let res = await browseProgram(params);
      let resData = res.data;
      if (resData.code === 200) {
        this.info = { ...resData.data };
        this.shareData = {
          title: `2022年“最美湖州人”候选人公示投票${this.info.title}`,
          contentURL: `https://prod-app-frontend.zhijianmedia.cn/piano-vote/#/Detail?id=${this.id}&ifAssisted=false`,
          brief: "等你来投票！",
          imageLink:
            "https://oss2upload.zhijianmedia.cn/common/0_2022121122464942085782905.jpeg",
        };
      }
    },
    backPage() {
      this.$router.go(-1);
    },
  },
  destory() {},
  mounted() {
    window.scrollTo(0, 0);
    var u = navigator.userAgent;
    var ua = u.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) {
      this.isIos = true;
    }
  },
  created() {
    SmartCity.hideTopView({
      isShow: 0,
    });
    this.isSmartCityApp = SmartCity.isSmartCityApp();
    // this.isSmartCityApp = true;
    this.id = JSON.parse(this.$route.query.id);
    // let item = JSON.parse(this.$route.query.item);
    // this.ifAssisted = JSON.parse(this.$route.query.ifAssisted);
    // this.activeTab = this.$route.query.activeTab;
    this.browseProgram();
    // this.info = item;
    if (process.env.NODE_ENV === "development") {
      this.isSmartCityApp = true;
    }
  },
};
</script>
<style lang="less" scoped>
@mainColor: #ff7e00;
@mainBgColor: #b4251e;
.noSmart {
  // padding-top: 100px !important;
}
.container {
  background: @mainBgColor url("../assets/topBg.jpeg") center top no-repeat;
  background-size: contain;
  padding-top: 100px;
  padding-bottom: 40px;
  min-height: calc(100vh);
  .banner-wrap {
    width: 100%;
    height: 200px;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .intr {
    margin: 0 10px 0;
    background: #fff;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    overflow: hidden;
    .avatar {
      width: 160px;
      height: 200px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .desc {
      padding: 20px;
      line-height: 22px;

      text-indent: 2em;
    }
    .name {
      padding: 6px;
      font-size: 16px;
      font-weight: bold;
      //   text-indent: 2em;
    }
    .title {
      font-size: 18px;
      font-family: PingFang;
      font-weight: 800;
      color: @mainColor;
      line-height: 1.5em;
    }
    .names {
      font-size: 14px;
      font-family: PingFang;
      font-weight: 400;
      color: #000000;
      line-height: 27px;
      margin: 9px auto 22px;
    }
    .content {
      font-size: 14px;
      font-family: FZLTHK;
      font-weight: normal;
      color: #000000;
      line-height: 27px;
      margin: 31px 16px 20px;
      text-align: justify;
    }
    .voteInfo {
      position: absolute;
      top: 0;
      left: 0;
      width: calc(113px - 15px);
      height: 43px;
      background: linear-gradient(89deg, #ff4d28 0%, #ff9d19 100%);
      border-bottom-right-radius: 45px;
      font-size: 18px;
      line-height: 43px;
      font-family: PingFang;
      font-weight: 800;
      color: #ffffff;
      padding-left: 15px;
    }
  }
  .backBtn {
    width: 353px;
    height: 39px;
    background: @mainColor;
    border-radius: 20px;
    font-size: 18px;
    font-family: FZLTCHJW;
    font-weight: normal;
    color: #ffffff;
    line-height: 39px;
    text-align: center;
    margin: 22px auto;
  }

  .btn {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    background: #3992f6;
    margin-top: 10px;
    .van-button {
      width: 100%;
      height: 100%;
    }
    // background-color: @main;
    // line-height: 1.2rem;
    // text-align: center;
    // color: #f2f2f2;

    //   font-size: 18px;
    //   font-weight: bold;
  }
}
.infoContent {
  // min-height: calc(100vh - 119px - 54px);
  // background: #f08943;
  padding: 19px 10px 0;
  .insideContent {
    // height: 244px;
    // box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 1);
    padding-top: 14px;
    padding-bottom: 40px;
    .infoDetail {
      background: #fff;
      border-radius: 5px;
      padding: 17px 10px 21px;
      > div {
        margin-bottom: 15px;
      }
      .mainTitle {
        text-align: center;
        font-weight: bold;
        font-size: 20px;
        margin-bottom: 10px;
      }
      .title {
        font-size: 14px;
        font-family: PingFang;
        color: #333;
        line-height: 1.5em;
        text-align: center;
      }
      .programName {
        flex-shrink: 1;
        font-size: 15px;
        font-weight: normal;
        color: @mainColor;
        width: 50%;
      }
      .infoText {
        text-indent: 2em;
        text-align: justify;
        color: #313131;
        // width: 70%;
        line-height: 1.5em;
      }
    }
  }
}
.myVideo {
  width: 100vw;
}
.mainImg {
  width: 320px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
<style lang="less">
/deep/ .vjs-progress-control {
  pointer-events: none !important;
}
.vjs-progress-control {
  display: none !important;
}
</style>